<template>
	<div class="schedule mh-700">
		<v-flex xs12>
			<ViewHeader
				src="https://firebasestorage.googleapis.com/v0/b/icbem2020-c618e.appspot.com/o/images%2Fposts-peppers-h600.jpg?alt=media&token=79843e04-6633-4934-b655-d534fba24aab"
				title="Scientific Program"
			/>
		</v-flex>
		<v-flex xs12>
			<div class="padded">
				<p>You can download a copy of the ICBEM 2022 program book <a href='/account' class="normal-link">from your Account page</a> (you need to be logged in and already registered for the conference)</p>
			</div>
		</v-flex>
		<v-flex xs12>
			<div class="padded">
				<Timeline
					v-for="item in schedule.items"
					:key="item.index"
					:day="item.day"
					:timelineItems="item.daySchedule"
					:isSession="item.isSession"
				/>
			</div>
		</v-flex>
	</div>
</template>

<script>
import Timeline from '@/components/Timeline.vue';
import ViewHeader from '@/components/ViewHeader.vue';
export default {
	name: 'schedule',
	components: {
		Timeline,
		ViewHeader
	},
	data: function() {
		return {
			title:
				'14th International Conference on Brain Energy Metabolism Oct. 24-27, 2022',
			subtitle:
				'Energy substrates and microbiome govern energetics and cognitive functions in adult and aging brain',
			subscript: 'Tentative Program and Schedule',
			schedule: {
				items: [
					{
						day: 'Monday, October 24, 2022',
						daySchedule: [
							{
								time: '12:00 - 6:00 PM',
								title: 'ICBEM Registration',
								location: 'Mezzanine (2nd Floor)',
								pdfLink: null,
								isSession: false
							},
							{
								time: '6:00 - 6:15 PM',
								title:
									'Welcome and acknowledgement of funding agencies: In-Young Choi, Tribute to John Edmond: Mary McKenna',
								location: 'Lumpkin Ballroom',
								pdfLink: null,
								isSession: false
							},
							{
								time: '6:15 - 7:30 PM',
								title: 'Plenary Lecture',
								chairs: 'Gary Yellen (USA)',
								location: 'Lumpkin Ballroom',
								sessions: [
									{
										speaker: 'Timothy Ryan',
										institution:
											'Weill College of Medicine, New York City, New York, USA',
										title:
											'The rules for fueling synapse function: metabolic vulnerabilities and backups',
										pdfLink: null
									}
								],
								isSession: false
							},
							{
								time: '7:30 - 9:30 PM',
								title: 'Opening Reception/Dinner',
								location: 'La Terraza',
								pdfLink: null,
								isSession: false
							}
						]
					},
					{
						day: 'Tuesday, October 25, 2022',
						daySchedule: [
							{
								time: '7:00 - 8:15 AM',
								title: 'Breakfast',
								location: 'La Terraza',
								isSession: false
							},
							{
								time: '8:30 - 10:30 AM',
								title: 'Student-Postdoctoral fellow award presentations (listed in order of presentation)',
								chairs: 'Jordi Duran (Spain) and Phil Lee (USA)',
								sessions: [
									{
										speaker: 'Alexandros Kokotos',
										institution:
											'Weill Cornell Medicine, New York, New York, USA',
										title: 'Nerve terminal PGK1 is a critical control point for fueling synaptic function'
									},
									{
										speaker: 'Quan Gan',
										institution:
											'Johns Hopkins University, Baltimore, Maryland, USA',
										title: 'The effect of acute ATP depletion on synaptic vesicle endocytosis at the ultrastructural level'
									},
									{
										speaker: 'Nicola Palandt',
										institution:
											'Ludwig Maximilian University of Munich, Germany',
										title: 'Frequency dependence of ATP generating pathways in an auditory brainstem nucleus'
									},
									{
										speaker: 'Elisa York',
										institution:
											'Harvard Medical School, Cambridge, Massachusetts, USA',
										title: 'Mass spectrometry imaging reveals dentate granule neuron fuel use during rest and stimulation'
									},
									{
										speaker: 'Bernhard Groschup',
										institution:
											'Institute For Stroke And Dementia Research, Munich, Germany',
										title: 'GABA mediates a Warburg-like shift of neuronal metabolism from OXPHOS to glycolysis'
									},
									{
										speaker: 'Jens Andersen',
										institution:
											'University of Copenhagen, Copenhagen, Denmark',
										title: 'Impaired GABA metabolism in Alzheimer’s disease'
									},
									{
										speaker: 'Thea Anderson',
										institution:
											'Georgia State University, Atlanta, Georgia, USA',
										title: `Obesity and prodromal Alzheimer's brain metabolism`
									},
									{
										speaker: 'Weizhi Xu',
										institution:
											'The University of Queensland, Brisbane, Australia',
										title: 'Brain insulin signalling and GLUT4 expression are altered in the chronic stage of mouse pilocarpine model of epilepsy'
									},
									{
										speaker: 'Kia Markussen',
										institution:
											'University of Kentucky, Lexington, Kentucky, USA',
										title: 'Lafora disease: a metabolic fingerprint in mouse and human'
									},
									{
										speaker: 'Regina Fernandez',
										institution:
											'Johns Hopkins University, Baltimore, Maryland, USA',
										title: 'Adaptations of fatty acid metabolism after neonatal brain injury'
									},
									{
										speaker: 'Gabriela De Paula',
										institution:
											'Lund University, Lund, Sweden',
										title: 'Microglia-derived energy metabolism distinct patterns under fatty acid remodeling'
									},
									{
										speaker: 'Gökhan Uruk',
										institution:
											'University of California San Francisco, San Francisco, California, USA',
										title: 'Inflammation-induced microglial nitric oxide production is glucose dependent'
									},
								],
								location: 'Lumpkin Ballroom',
								pdfLink: null,
								isSession: false
							},
							{
								time: '10:30 - 11:00 AM',
								title: 'Coffee break',
								location: null,
								isSession: false
							},
							{
								time: '11:00 AM - 12:30 PM',
								title:
									'Session 1. Neuronal energetics: Ion pumping and signaling, memory',
								chairs: 'Arne Schousboe (Denmark) and Mukesh Kumar (USA)',
								location: 'Lumpkin Ballroom',
								sessions: [
									{
										speaker: 'L. Felipe Barros',
										institution:
											'Centro de Estudios Científicos (CECs) & Universidad San Sebastián, Valdivia, Chile',
										title:
											'Hypersensitive control of mitochondrial ATP production in neurons  involves the Na+ pump',
										pdfLink: null
									},
									{
										speaker: 'Carlos Diaz-Garcia',
										institution:
											'University of Oklahoma, Oklahoma City, Oklahoma, USA',
										title:
											'Calcium fluxes and ion pumping orchestrate NADH production in stimulated neurons',
										pdfLink: null
									},
									{
										speaker: 'Ewan McNay',
										institution:
											'University of Albany, Albany, New York, USA',
										title:
											'Insulin-signaling upregulates GLUT4 in hippocampal neurons: required for memory',
										pdfLink: null
									}
								],
								isSession: true
							},
							{
								time: '12:30 - 1:30 PM',
								title: 'Buffet Lunch',
								location: 'La Terraza',
								description:
									'Student/postdoc lunch with session speakers/other scientists; open seating for all others',
								isSession: false
							},
							{
								time: '1:30 PM - 3:00 PM',
								title:
									'Session 2. Beyond glucose storage: Glycogen involved in neuronal activation, learning/memory, seizures',
								chairs: 'Raymond A. Swanson (USA) and Regina Fernandez (USA)',
								sessions: [
									{
										speaker: 'Douglas L. Rothman',
										institution:
											'Yale University, New Haven, Connecticut, USA',
										title:
											'Astrocytic glycogenolysis spares glucose for neurons during activation',
										pdfLink: null
									},
									{
										speaker: 'Matthew Gentry',
										institution:
											'University of Kentucky, Lexington, Kentucky, USA',
										title:
											'Brain glycogen - more than just a glucose cache',
										pdfLink: null
									},
									{
										speaker: 'Jordi Duran',
										institution:
											'Instituto Químico de Sarriá Barcelona & Institute for Bioengineering of Catalonia, Barcelona, Spain',
										title:
											'Dissecting the specific roles of astrocytic and neuronal glycogen in memory formation, synaptic plasticity and glycogen-induced neurodegeneration',
										pdfLink: null
									}
								],
								location: 'Lumpkin Ballroom',
								isSession: true
							},
							{
								time: '3:00 - 3:30 PM',
								title: 'Coffee break',
								location: null,
								pdfLink: null,
								isSession: false
							},
							{
								time: '3:30 - 5:00 PM',
								title: 'Student/postdoc "Poster Power Pitch"',
								chairs: 'In-Young Choi (USA) and L. Felipe Barros (Chile)',
								sessions: [
									{
										speaker: 'Neal Bennet',
										institution:
											'Gladstone Institutes, San Francisco, California, USA'
									},
									{
										speaker: 'Antoine Cherix',
										institution:
											'University of Oxford, Oxford, UK'
									},
									{
										speaker: 'Isabel Christie',
										institution:
											'University College London, London, UK'
									},
									{
										speaker: 'Khanh Doan',
										institution:
											'Yonsei University College of Dentistry, Seoul, South Korea'
									},
									{
										speaker: 'Ashwini Hariharan',
										institution:
											'University of Maryland Baltimore, Baltimore, Maryland, USA'
									},
									{
										speaker: 'Mukesh Kumar',
										institution:
											'Weill Cornell Medical College, New York, New York, USA'
									},
									{
										speaker: 'Dasfne Lee-Liu',
										institution:
											'University of Chile, Santiago, Chile'
									},
									{
										speaker: 'Sanna Loppi',
										institution:
											'University of Arizona, Phoenix, Arizona, USA'
									},
									{
										speaker: 'Anne Miller',
										institution:
											'Harvard Medical School, Cambridge, Massachusetts, USA'
									},
									{
										speaker: 'Hung Nguyen',
										institution:
											'Oregon Health & Science University, Portland, Oregon, USA'
									},
									{
										speaker: 'Shefeeq Theparambil',
										institution:
											'University College London, London, UK'
									},
									{
										speaker: 'Sarah Zerimech',
										institution:
											'Oregon Health & Science University, Portland, Oregon, USA'
									},
									{
										speaker: 'Cory White',
										institution:
											'Johns Hopkins University School of Medicine, Baltimore, Maryland, USA'
									},
									{
										speaker: 'Afroditi Eleftheriou',
										institution:
											'University of Zurich, Zurich, Switzerland'
									},
									{
										speaker: 'Kirsten Bredvik',
										institution:
											'Weill Cornell Medical College, New York, New York, USA'
									},
									{
										speaker: 'Bernardo Antunes',
										institution:
											'Instituto de Medicina Molecular João Lobo Antunes, Lisbon, Portugal'
									},
									{
										speaker: 'Starlette Douglass',
										institution:
											'SUNY University at Albany, Albany, New York, USA'
									},
									{
										speaker: 'Fernando Gonzalez Ibanez',
										institution:
											'Université Laval-University, Quebec City, Canada; University of Victoria, Victoria, British Columbia, Canada'
									},
									{
										speaker: 'Jimmy Harrison',
										institution:
											'University of Kentucky, Lexington, Kentucky, USA'
									},
									{
										speaker: 'Sarah Kaye',
										institution:
											'Wake Forest School of Medicine, Winston-Salem, North Carolina, USA'
									},
									{
										speaker: 'Martin Woergaard Kjaer',
										institution:
											'University of Copenhagen, Copenhagen, Denmark'
									},
									{
										speaker: 'Marisa Mekkittikul',
										institution:
											'University of California Los Angeles, Los Angeles, California, USA'
									},
									{
										speaker: 'Mitchell Moyer',
										institution:
											'University of Maryland, College Park, Maryland, USA'
									},
									{
										speaker: 'Lilian Oliveira',
										institution:
											'University of São Paulo, São Paulo, Brazil'
									},
									{
										speaker: 'Alexandra von Faber-Castell',
										institution:
											'University of Zurich, Zurich, Switzerland'
									},
									{
										speaker: 'Christopher Ware',
										institution:
											'Georgia State University, Atlanta, Georgia, USA'
									},
									{
										speaker: 'Emil Westi',
										institution:
											'University of Copenhagen, Copenhagen, Denmark'
									},
									{
										speaker: 'Diana Frida De Lima',
										institution:
											'Centro de Investigación y de Estudios Avanzados del Instituto Politécnico Nacional, Mexico City, Mexico'
									},
									{
										speaker: 'Ivonne Romero Flores',
										institution:
											'Centro de Investigación y de Estudios Avanzados del Instituto Politécnico Nacional, Mexico City, Mexico'
									},
									{
										speaker: 'Kenneth Oparaji ',
										institution:
											'Alex Ekwueme Federal University Ndufu-Alike, Ndufu, Alike Ikwo of Ebonyi State, Nigeria'
									},
									{
										speaker: 'Ochuko Erukainure',
										institution:
											'University of the Free State, Bloemfontein, South Africa'
									},
									{
										speaker: 'Jae Hyouk Choi',
										institution:
											'University of California San Diego, La Jolla, California, USA'
									}
									
								],
								location: 'Lumpkin Ballroom',
								pdfLink: null,
								isSession: false
							},
							{
								time: '5:00 - 7:00 PM',
								title: 'Poster session I',
								location: 'Lumpkin Ballroom',
								pdfLink: null,
								isSession: false
							},
							{
								time: '7:00 - 8:00 PM',
								title: 'Dinner',
								location: 'La Terraza',
								pdfLink: null,
								isSession: false
							},
							{
								time: '8:00 - 10:00 PM',
								title: 'Poster session II',
								location: 'Lumpkin Ballroom',
								pdfLink: null,
								isSession: false
							}
						]
					},
					{
						day: 'Wednesday, October 26, 2022',
						daySchedule: [
							{
								time: '7:00 - 8:15 AM',
								title: 'Breakfast',
								location: 'La Terraza',
								isSession: false
							},
							{
								time: '8:30 - 10:00 AM',
								title:
									'Session 3. Higher brain functions: Astrocyte-neuron interactions, cognition, and memory',
								chairs: 'Michael Robinson (USA) and Kia Markussen (USA)',
								sessions: [
									{
										speaker: 'Adi Kol',
										institution:
											'Inbal Goshen Lab, Hebrew University, Jerusalem, Israel',
										title:
											"Astrocytic modulation of neuronal activity in recent and remote memory (presented over Zoom)",
										pdfLink: null
									},
									{
										speaker: 'Robert Zorec',
										institution:
											'University of Ljubljana, Ljubljana, Slovenia',
										title:
											"Locus coeruleus noradrenergic astrocytic excitation, gliotransmission, and cognitive decline in aging and Alzheimer's disease",
										pdfLink: null
									},
									{
										speaker: 'Oliver Kann',
										institution:
											'University of Heidelberg, Heidelberg, Germany',
										title:
											'Energetics of hippocampal gamma oscillations that underlie cognitive functions',
										pdfLink: null
									}
								],
								location: 'Lumpkin Ballroom',
								isSession: true
							},
							{
								time: '10:00 - 10:30 AM',
								title: 'Coffee break',
								location: null,
								isSession: false
							},
							{
								time: '10:30 AM - 12:00 PM',
								title:
									"Session 4. Dietary intervention: Impact on aging, memory, and Alzheimer's disease",
								chairs: 'Nina Vardjan (Slovenia) and Bernhard Groschup (Germany)',
								sessions: [
									{
										speaker: 'Claudia Perez-Cruz',
										institution:
											'Center for Research and Advanced Studies of the National Polytechnic Institute (CINVESTAV), Mexico City, Mexico',
										title:
											'Bioactive foods modulate the release of bacterial products: prevention of neuroinflammation and cognitive decline in an Alzheimer mouse model (presented over Zoom)',
										pdfLink: null
									},
									{
										speaker: 'Joseph Baur',
										institution:
											'University of Pennsylvania, Philadelphia, Pennsylvania, USA',
										title:
											'NAD and energy metabolism in mammalian tissues',
										pdfLink: null
									},
									{
										speaker: 'Robert Pawlosky',
										institution:
											'Laboratory of Metabolic Control, National Institute of Alcohol Abuse and Alcoholism/National Institutes of Health, Bethesda, Maryland, USA',
										title:
											'Dietary ketone ester: Neuroprotective in Alzheimer model mice and performance enhancer',
										pdfLink: null
									}
								],
								location: 'Lumpkin Ballroom',
								isSession: true
							},
							{
								time: '12:00 - 1:00 PM',
								title: 'Buffet Lunch',
								location: 'La Terraza',
								pdfLink: null,
								isSession: false
							},
							{
								time: '1:00 - 2:30 PM',
								title:
									'Session 5. Gut-brain signaling: Microbiome influences higher brain functions',
								chairs: 'Mary C. McKenna (USA) and Gabriela De Paula (Sweden)',
								sessions: [
									{
										speaker: 'Melanie Kaelberer',
										institution:
											'D. Bohórquez Lab, Duke University, Durham, North Carolina, USA',
										title: `Sensory transduction in the gut`,
										pdfLink: null
									},
									{
										speaker: 'Christine Olson',
										institution:
											'P. Turnbaugh Lab, University of California San Francisco, San Francisco, California, USA',
										title:
											'Gut microbiome mediates effects of ketogenic diet: anti-seizure activity and hippocampal GABA/glutamate levels',
										pdfLink: null
									},
									{
										speaker: 'Shelly Buffington',
										institution:
											'University of Texas Medical Branch, Galveston, Texas, USA',
										title:
											'Host-microbe interactions regulating synaptic plasticity and behavior',
										pdfLink: null
									}
								],
								location: 'Lumpkin Ballroom',
								isSession: true
							},
							{
								time: '2:30 - 3:00 PM',
								title:
									'ISN Announcement (Caroline "Lindy" Rae); Journal of Neurochemistry student poster awards (Mary McKenna); A tribute to Sebastian Cerdan (Mary McKenna)',
								location: 'La Terraza',
								pdfLink: null,
								isSession: false
							},
							{
								time: '3:00 - 3:30 PM',
								title: 'Coffee Break',
								location: null,
								pdfLink: null,
								isSession: false
							},
							{
								time: '3:30 - 5:00 PM',
								title:
									'Session 6. Mitochondria and their metabolites: Sleep, neurotransmission, and memory',
								chairs: 'Caroline (Lindy) Rae (Australia) and Bernardo Antunes (Portugal)',
								sessions: [
									{
										speaker: 'Berrak Ugur',
										institution:
											'P. De Camilli Lab., Yale University, New Haven, Connecticut, USA',
										title:
											'\u03B1-Ketoglutarate couples TCA cycle with synaptic transmission in photoreceptors and neuromuscular junction (presented over Zoom)',
										pdfLink: null
									},
									{
										speaker: 'Gero Miesenböck',
										institution:
											'University of Oxford, Oxford, UK',
										title: `Energy metabolism, mitochondrial redox state, and sleep`,
										pdfLink: null
									},
									{
										speaker: 'Ignacio Fernandez Moncada',
										institution:
											'National Institute of Health and Medical Research (INSERM), University of Bordeaux, Bordeaux, France',
										title:
											'Cannabinoid CBR1 receptors govern mitochondrial metabolism and memory',
										pdfLink: null
									}
								],
								location: 'Lumpkin Ballroom',
								isSession: false
							},
							{
								time: '5:00 - 6:00 PM',
								title: 'Thinking about sensors: Principles and practice of fluorescent biosensor quantitation and interpretation',
								chairs: 'C. William Shuttleworth (USA)',
								sessions: [
									{
										speaker: 'Dorothy Koveal',
										institution:
											'Georgia Tech, Atlanta, Georgia, USA',
										title:
											'Functional principles of fluorescent biosensor development and their quantitative use',
										pdfLink: null
									}
								],
								location: 'Lumpkin Ballroom',
								pdfLink: null,
								isSession: false
							},
							{
								time: '6:00 - 7:30 PM',
								title: 'Dinner',
								location: 'La Terraza',
								pdfLink: null,
								isSession: false
							},
							{
								time: '7:30 - 9:00 PM',
								title:
									'Session 7. Metabolic neuroimaging in aging and neurodegeneration',
								chairs: 'Kelly Drew (USA) and Jens Andersen (Denmark)',
								sessions: [
									{
										speaker: 'Phil Lee',
										institution:
											'University of Kansas Medical Center, Kansas City, Kansas, USA',
										title: `Cerebral metabolic changes and influencing factors in aging and neurodegeneration`,
										pdfLink: null
									},
									{
										speaker: 'João M. N. Duarte',
										institution:
											'Lund University, Lund, Sweden',
										title:
											"Hormone-sensitive lipase contributes for brain metabolism regulation, and its deletion impairs memory in aged mice",
										pdfLink: null
									},
									{
										speaker: 'Wei Chen',
										institution:
											'University of Minnesota, Minneapolis, Minnesota, USA',
										title:
											'Quantitative study of human brain aging and neurodegeneration using advanced neurometabolic imaging',
										pdfLink: null
									}
								],
								location: 'Lumpkin Ballroom',
								isSession: true
							}
						]
					},
					{
						day: 'Thursday, October 27, 2022',
						daySchedule: [
							{
								time: '7:00 - 8:15 AM',
								title: 'Breakfast',
								location: 'La Terraza',
								isSession: false
							},
							{
								time: '8:30 - 10:00 AM',
								title:
									'Session 8. Spreading depolarization in brain injury and repair in adult and aging brain',
								chairs: 'Susanna Scafidi (USA) and Quan Gan (USA)',
								sessions: [
									{
										speaker: 'C. William Shuttleworth',
										institution:
											'University of New Mexico, Albuquerque, New Mexico, USA',
										title: `Mechanisms of acute brain injury and recovery in metabolically compromised brain`,
										pdfLink: null
									},
									{
										speaker: 'Eszter Farkas',
										institution:
											'University of Szeged, Szeged, Hungary',
										title:
											'Spreading depolarization predicts impaired reperfusion in the mouse cerebral cortex',
										pdfLink: null
									},
									{
										speaker: 'Britta Lindquist',
										institution:
											'Fellow, Neurocritical Care, University of California San Francisco, San Francisco, California, USA',
										title:
											'Clinical and translational studies of spreading depolarization',
										pdfLink: null
									}
								],
								location: 'Lumpkin Ballroom',
								isSession: true
							},
							{
								time: '10:00 AM - 11:30 AM',
								title:
									'Informal Roundtable Discussion: Hot topics and debated issues',
								chairs: 'Wei Chen (USA), Arne Schousboe (Denmark), Caroline (Lindy) Rae (Australia), Mike Robinson (USA)',
								description: `10:00-11:00 new techniques/hot topics by selected conferees 
											  11:00-12:00 breakouts to discuss debated issues identified by conference participants`,
								location: 'Lumpkin Ballroom',
								isSession: false
							},
							{
								time: '12:00 - 12:30 PM',
								title:
									'Pick up box lunch and board buses (lunch on bus during travel)',
								isSession: false
							},
							{
								time: '12:30 - 1:30 PM',
								title: 'Travel to Bandelier National Monument',
								description: '',
								isSession: false
							},
							{
								time: '1:30 - 4:30 PM',
								title:
									'Visit the Ancestral Pueblo site with informal discussions among conferees',
								description: '',
								isSession: false
							},
							{
								time: '4:30 - 5:45 PM',
								title: 'Bus travel back to La Fonda',
								description: '',
								isSession: false
							},
							{
								time: '5:45 - 6:00 PM',
								title: 'Conference evaluation',
								description: '',
								location: 'Lumpkin Ballroom',
								isSession: false
							},
							{
								time: '7:00 - 9:30 PM',
								title: 'Closing dinner',
								description: '',
								location: 'La Terraza',
								isSession: false
							}
						]
					}
				]
			}
		};
	}
};
</script>
